<template>
  <router-view v-loading="flagLoadingAllScreen !== 0" />
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'app-main',
  computed: {
    ...mapGetters(['flagLoadingAllScreen'])
  }
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/App-main.vue